import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-city-details',
  templateUrl: './city-details.component.html',
  styleUrl: './city-details.component.scss'
})
export class CityDetailsComponent {

  constructor(public route: Router, private location: Location) {}
  goBackToPrevPage(): void {
    if(this.route.url == '/' || this.route.url == '/dashboard') {
      return
    }
    else{
      this.location.back();
    }
  }
}
